import * as React from 'react';
import {withI18n, WithI18nProps} from 'packages/@shopify/react-i18n';
import * as locales from '../../locales';

// Without this typescript expects `i18n`
export interface HomeHeaderProps {}

function HomeHeaderComponent({i18n}: HomeHeaderProps & WithI18nProps) {
  return (
    <div className="grid">
      <div className="grid__item">
        <div className="section-heading section-heading--left gutter-bottom">
          <h1 className="section-heading__kicker heading--5 gutter-bottom--half">{i18n.translate('header.kicker')}</h1>
          <p className="section-heading__heading heading--1 gutter-bottom--half">{i18n.translate('header.header')}</p>
          <p className="section-heading__subhead heading--4">{i18n.translate('header.subhead')}</p>
        </div>
      </div>
    </div>
  );
}

export const HomeHeader = withI18n({
  id: 'Home',
  fallback: locales.en,
})(HomeHeaderComponent);

export default HomeHeader;
